import { US_DATE_SHORT, formatDate } from '@/common/constants';
import { UPLOAD_CLIENT_DOCUMENT } from '@/stores/actions.type';
import { NOTIFICATION_TYPES, NotificationService } from '@/services/notification.service';

const DocumentsMixin = {
  methods: {
    /**
     * Format document list from client progress
     * @returns {Array} Formatted document list
     */
    getFormattedDocuments() {
      return this.clientProgress
        ? this.clientProgress.uploads.map(({ name, updatedAt, ...rest }) => ({
            id: name,
            name: name.replace(
              /(?<=[a-z])(?=[A-Z])|(?<=[A-Z])(?=[A-Z][a-z])/g,
              ' ',
            ),
            uploaded: updatedAt ? formatDate(updatedAt, US_DATE_SHORT) : null,
            ...rest,
          }))
        : [];
    },

    /**
     * Check if a document is optional
     * @param {Object} doc - Document object
     * @returns {Boolean} Whether document is optional
     */
    isOptionalDoc(doc) {
      return ['CancelledCheck', 'BrokerageStatement'].includes(doc.id);
    },
    
    /**
     * Check if all required documents are complete
     * @param {Array} documents - List of documents
     * @returns {Boolean} Whether all required documents are complete
     */
    areDocumentsComplete(documents) {
      if (!documents || documents.length === 0) {
        return true;
      }

      return (
        documents.find(
          (d) => !this.isOptionalDoc(d) && d.uploaded === null,
        ) === undefined
      );
    },
    
    /**
     * Upload a document
     * @param {Object} doc - Document to upload
     * @returns {Promise} Upload promise
     */
    uploadDocument(doc) {
      const payload = {
        documentName: doc.id,
        accountId: doc.accountId,
        file: doc.file,
        feature: doc.feature,
      };
      
      return this.$store
        .dispatch(UPLOAD_CLIENT_DOCUMENT, payload)
        .then(() => {
          NotificationService.alert({
            type: NOTIFICATION_TYPES.SUCCESS,
            title: 'Success',
            message: 'Document successfully uploaded!',
            okTitle: 'Ok',
          });
        })
        .catch((response) => {
          NotificationService.alert(
            {
              type: NOTIFICATION_TYPES.ERROR,
              title: 'Error',
              message: 'Error uploading document!',
              okTitle: 'Ok',
            },
            response,
          );
        });
    }
  }
};

export default DocumentsMixin; 